import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { BAC_HOME } from './bac.data';
import {
  TranslateModule,
  TranslateService,
  TranslatePipe,
} from '@ngx-translate/core';
import { TestimonialComponent } from '../../../Components/testimonial/testimonial.component';
import { CarouselComponent } from '../../../Components/carousel/carousel.component';
import { PhotoGalleryComponent } from '../../../Components/photogallery/photogallery.component';
import { BaseComponent } from '../../base.component';
import { ITestimonial } from '../../../Components/testimonial/testimonial.model';
import { AutoUnsubscribe } from '../../../Services/autoUnsubscribe.service';
import { SchoolApiService } from '../../../Services/schoolApi.service';
import {
  DOMAIN_TYPE,
  SCHEMA_TYPE,
  NATIONAL_PAGES,
  BAC_PAGES,
} from '../../../constants';
import { IList } from '../../../Models/list.model';
import { IResponse } from '../../../Models/response.model';
import { ISchoolArticle } from '../../../Models/schoolArticle.model';
import { IPhotoGallery } from '../../../Components/photogallery/photogallery.model';

@AutoUnsubscribe()
@Component({
  selector: 'app-bac-home',
  standalone: true,
  imports: [
    TranslateModule,
    TestimonialComponent,
    CarouselComponent,
    PhotoGalleryComponent,
  ],
  providers: [TranslateService, TranslatePipe, SchoolApiService],
  templateUrl: './bac-home.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BacHomeComponent extends BaseComponent {
  public BAC_HOME = BAC_HOME;
  public bacNewsCarousel: ISchoolArticle[] = [];

  public start: number = 0;
  public limit: number = Number.MAX_SAFE_INTEGER;
  public totalcount: number;
  public testimonialData: ITestimonial[];
  public galleryData: IPhotoGallery[];

  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef,
  ) {
    super(schoolApiService);
    this.domainType = DOMAIN_TYPE.BAC;
  }

  ngOnInit(): void {
    this.getOnHomeNews();
    this.getTestimonials();
    this.getPhotoGallery();
  }
  getOnHomeNews() {
    this.schemaType = SCHEMA_TYPE.ARTICLE;
    this.articleType = NATIONAL_PAGES.NEWS;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType, isShownOnHome: 'true' },
        isArchived: false,
        language: this.language,
        start: 0,
        limit: 5,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.bacNewsCarousel = this.mapArticles(data.payload?.list || []);
          this.cdr.detectChanges();
        }
      });
  }

  getTestimonials() {
    this.schemaType = SCHEMA_TYPE.GENERAL;
    this.articleType = BAC_PAGES.HOME.TESTIMONIAL;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: this.start,
        limit: this.limit,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.totalcount = data.payload?.count || 0;
          this.testimonialData = this.mapTestimonials(data.payload?.list || []);
          this.cdr.detectChanges();
        }
      });
  }

  getPhotoGallery() {
    this.schemaType = SCHEMA_TYPE.GENERAL;
    this.articleType = NATIONAL_PAGES.HOME.GALLERY;
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: 0,
        limit: 1,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.galleryData = this.mapPhotoGallery(data.payload?.list || []);
          this.cdr.detectChanges();
        }
      });
  }
}
